import { render, staticRenderFns } from "./ReemplazarInscripcionDocumentoPersona.vue?vue&type=template&id=e950f8e8&scoped=true"
import script from "./ReemplazarInscripcionDocumentoPersona.vue?vue&type=script&lang=js"
export * from "./ReemplazarInscripcionDocumentoPersona.vue?vue&type=script&lang=js"
import style0 from "./ReemplazarInscripcionDocumentoPersona.vue?vue&type=style&index=0&id=e950f8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e950f8e8",
  null
  
)

export default component.exports